<template>
  <div>
    <popup
      :show.sync="is_popup_show_detail"
      height="680px"
      width="980px"
      @on-close="close_fabric_detail"
    >
      <div class="fabric-content-wrap" style="height: 100% !important">
        <div class="info-wrap">
          <div class="left-popup">
            <div
              v-if="
                (detail.image_list &&
                  detail.image_list.length > 0) ||
                detail.video
              "
              class="slider"
            >
              <swiper ref="swiper" :options="swiperOption">
                <swiper-slide v-if="detail.video">
                  <video
                    v-if="detail.video"
                    :src="detail.video"
                    muted
                    autoplay
                    controls
                    id="video-material"
                  >
                    
                  </video>
                </swiper-slide>
                <swiper-slide
                  v-for="(item, index) in detail.image_list"
                  :key="`sl` + index"
                >
                  <img v-viewer :src="item.url" class="img" />
                </swiper-slide>
                
                <div slot="button-prev" class="swiper-button-prev"></div>
                <div slot="button-next" class="swiper-button-next"></div>
              </swiper>
            </div>
          </div>
          <div class="right" v-if="type=='fabric'">
            <p class="name">{{ detail.fabric_name_en || detail.fabric_name_cn }}</p>
            <p class="no">Fabric No：{{ detail.fabric_key }}</p>
            <p class="price">
              Price:${{ detail.fabric_price
              }}{{
                detail.unit_en ? "/" + detail.unit_en : ""
              }}
            </p>
            <div
              class="title"
              style="border-top: 1px solid #e0e0e0; margin-bottom: 20px"
            >
              <!-- 面料参数 -->
            </div>
            <div class="list">
              <div class="item">
                <span class="key">Unit：</span
                ><span class="value">{{ detail.unit_en }}</span>
              </div>
              <div class="item">
                <span class="key">Width：</span
                ><span class="value"
                  >{{ detail.width_wide }} CM</span
                >
              </div>
              <div class="item">
                <span class="key">Weight：</span
                ><span class="value"
                  >{{ detail.weight
                  }}<template v-if="detail.unit_weight == 2"
                    >G/M<sup>2</sup></template
                  ><template v-if="detail.unit_weight == 1"
                    >G/M</template
                  ></span
                >
              </div>
              <div class="item">
                <span class="key">Composition：</span
                ><span class="value">{{ detail.component_en }}</span>
              </div>
              <div class="item">
                <span class="key">National Standard：</span
                ><span class="value">{{ detail.standard }}</span>
              </div>
              <div class="item">
                <span class="key" style="">Sample Service Provided：</span
                ><span class="value">{{
                  detail.is_support_send_sample ? "YES" : "No"
                }}</span>
              </div>
          
            </div>
          </div>
          <div class="right" v-if="type=='accessory'">
            <p class="name">{{ detail.accessory_name_en ||  detail.accessory_name}}</p>
            <p class="no">
              Accessory No：{{ detail.accessory_sku }}
            </p>
            <div class="title" style="border-top: 1px solid #e0e0e0">
              <!-- 辅料参数 -->
            </div>
            <div class="list">
              <div class="item">
                <span class="key">Unit：</span
                ><span class="value">{{
                  detail.measure_unit_en
                }}</span>
              </div>
              <div class="item">
                <span class="key">Specification：</span
                ><span class="value">{{ detail.spec }}</span>
              </div>
              <div class="item">
                <span class="key">Material：</span
                ><span class="value">{{
                  detail.material_en
                }}</span>
              </div>
              <div class="color-box">
                <div
                  v-for="(item, index) in detail.color_list"
                  :key="index"
                  :class="[
                    'color-item',
                    {
                      active:
                        detail.color_name_cn ===
                        item.color_name_cn,
                    },
                  ]"
                >
                  <img
                    v-viewer
                    @click.stop
                    :src="item.color_value | default_img"
                    alt=""
                    class="color-img"
                  />{{ item.color_name_cn }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="title-box" v-if="type=='fabric'">
          <div class="title">Color Selection</div>
          <div class="line"></div>
        </div>
        <div class="color-box" v-if="type=='fabric'">
          <div
            v-for="(item, index) in detail.color_list"
            :key="index"
           
            :class="[
              'color-item',
              {
                active:
                  detail.color_name_cn === item.color_name_cn,
              },
            ]"
          >
            <img
              v-viewer="{ url: 'data-source' }"
              @click.stop
              :src="item.color_value | default_img"
              :data-source="item.color_value"
              alt=""
              class="color-img"
            />{{ item.color_name_cn }}
          </div>
        </div>


        <div class="title-box">
          <div class="title">Product Details</div>
          <div class="line"></div>
        </div>
        <div
          class="richtext-wrap"
          v-html="detail.description"
        ></div>
      </div>
    </popup>
  </div>
</template>

<script>
import { GetFabric, GetAccessory } from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "FabricAccessoryShow",
  props: {},
  data() {
    return {
      is_popup_show_detail: false,
      swiperOption: {
        loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange: function () {
            if (document.getElementById("video-material")) {
              if (this.activeIndex === 0) {
                document.getElementById("video-material").play();
              } else {
                document.getElementById("video-material").pause();
              }
            }
          },
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      },
      id: 0,
      type: "fabric",
      detail: {
        image_list: [],
        color_list: [],
      },
    };
  },
   components: {
    Popup,
    swiper,
    swiperSlide,
  },
  watch: {},
  methods: {
    show(id, type) {
      this.id = id;
      this.type = type;
      this.get();
    },
    close_fabric_detail() {
        this.is_popup_show_detail = false
    },
    async get() {
      if (this.type == "fabric") {
        var { data } = await GetFabric({
          id: this.id,
        });
      } else {
        var { data } = await GetAccessory({
          id: this.id,
        });
      }
      this.detail = data;
      this.is_popup_show_detail = true;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.fabric-content-wrap {
  margin-top: 40px;
  overflow-y: scroll;
  height: 600px;
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: left;
  .title-box {
    display: flex;
    align-items: center;
    column-gap: 13px;
    .title {
      color: #1a1a1a;
      font-size: 16px;
      border-left: none;
      font-weight: bold;
      margin-bottom: 0;
      padding: 10px 0;
      height: auto;
    }
    .line {
      flex: 1;
      height: 1px;
      background: #ebebeb;
    }
  }

  .info-wrap {
    display: flex;
    justify-content: space-around;
    min-height: 430px;

    .left-popup {
      width: 420px;
      border: 1px solid #e5e5e5;
      .f-img {
        width: 420px;
        height: 420px;
      }
    }

    .right {
      // width: 500px;
      flex: 1;
      padding-right: 20px;
      padding-left: 20px;
      .name {
        color: #1a1a1a;
        font-size: 20px;
      }

      .no {
        color: #808080;
        font-size: 14px;
        margin-bottom: 20px;
        // margin: 25px 0;
      }
      .price {
        color: #e00000;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 17px;
      }
      .item {
        margin: 5px 0;

        .key {
          display: inline-block;
          color: #808080;
          // width: 80px;
        }

        .value {
          color: #1a1a1a;
        }
      }
      .color-title {
        color: #1a1a1a;
        font-size: 16px;
        font-weight: bold;
      }
      .color-box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        column-gap: 10px;
        row-gap: 10px;
        margin-top: 26px;
        max-height: 200px;
        overflow-y: auto;
        .color-item {
          width: 112px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 6px;
          border-radius: 5px;
          border: 1px solid #e5e5e5;
          color: #4d4d4d;
          cursor: pointer;
          .color-img {
            width: 25px;
            height: 25px;
            border-radius: 5px;
          }
          &.active {
            border: 1px solid #fa3d5a;
            color: #fa3d5a;
          }
        }
      }
    }
  }

  .color-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 10px;
    // margin-top:26px;
    // max-height:200px;
    // overflow-y:auto;
    .color-item {
      width: 112px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 6px;
      border-radius: 5px;
      border: 1px solid #e5e5e5;
      color: #4d4d4d;
      cursor: pointer;
      .color-img {
        width: 25px;
        height: 25px;
        border-radius: 5px;
      }
      &.active {
        border: 1px solid #fa3d5a;
        color: #fa3d5a;
      }
    }
  }

  .richtext-wrap {
    flex: 1;
    padding-bottom: 60px;
  }
  .btn-box {
    display: flex;
    justify-content: center;
    column-gap: 20px;
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background: #ffffff;
    padding: 10px 0;
    .cancel-btn {
      width: 120px;
      height: 38px;
      border-radius: 19px;
      background: #ffffff;
      border: 1px solid #e5e5e5;
      color: #1a1a1a;
      font-size: 14px;
      cursor: pointer;
    }
    .confirm-btn {
      width: 120px;
      height: 38px;
      border-radius: 19px;
      background: #1a1a1a;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
    }
  }
}

.slider {
  width: 420px;
  height: 420px;
  overflow: hidden;

  .swiper-slide {
    width: 420px;
    height: 420px;
  }

  .img,
  video {
    width: 420px;
    height: 420px;
    object-fit: contain;
  }
}

::v-deep .viewer-container {
  z-index: 999999 !important;
}

::v-deep .ivu-upload {
  width: 100%;
}
</style>
